import styled from '@emotion/styled';
import { alpha, Button } from '@mui/material';
import { shouldForwardProps } from '../../../utils';
import { ButtonLabel } from '../../../styles';

const OutlinedButtonWrapper = styled(Button, shouldForwardProps)`
    border-radius: 8 px;
    border: ${({ theme, disabled }) =>
        `1px solid ${disabled ? theme.colors.disabled : theme.colors.primary}`};
    padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};
    height: 48px;
    width: fit-content;

    &:hover {
        background-color: ${({ theme }) => alpha(theme.colors.primary, 0.08)};
    }

    &:focus {
        border: 2px solid ${({ theme }) => theme.colors.white};
        border-radius: 8px;
        box-shadow:
            0 0 0 2px ${({ theme }) => theme.colors.primary},
            0 0 0 4px ${({ theme }) => alpha(theme.colors.primary, 0.4)};
    }
`;

const OutlinedButtonLabel = styled(ButtonLabel, shouldForwardProps)<{
    hasIcon?: boolean;
    isDisabled?: boolean;
    labelColor?: string;
}>`
    margin-left: ${({ hasIcon, theme }) => (hasIcon ? theme.spacing(1) : 0)};
    color: ${({ theme, isDisabled, labelColor }) =>
        isDisabled ? theme.colors.disabledText : (labelColor ?? theme.colors.primary)};
    display: inline-block;
    white-space: nowrap;
`;

export { OutlinedButtonWrapper, OutlinedButtonLabel };
